<template>
  <div>
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
  </div>
</template>
<script>
import Toast from '@/components/Toast'
import { fetchCommodity, createOrder, getToken } from '@/services/q_commodity'
import { loginQ } from '@/utils/q_userinfo'
import { getPayTokenParam, openScheme, getSession, sessionKeys } from '@/utils/q_business'
import { Sniff } from '@/utils/q_sniff'
import sendLog from '@/utils/q_log'
export default {
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: ''
    }
  },
  watch: {
    payLoad(newVal) {
      if (!newVal) {
        return
      }
      // 未领取
      if (newVal.status === 1) {
        const logParam = {
          actPos: `${this.compIndex}_${newVal.commodityIndex}`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_commodity_use`
        }
        sendLog(logParam)
        this.goList(newVal)
      } else if (newVal.status === 2) {
        this.doShowToast('好可惜，该商品已经售完了')
      } else if (newVal.status === 0) {
        const logParam = {
          actPos: `${this.compIndex}_${newVal.commodityIndex}`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_commodity_buy`
        }
        sendLog(logParam)
        this.buyCommodity(newVal)
      }
    }
  },
  mounted() {
    this.initRedPacket()
  },
  methods: {
    /**
     * 商品初始化
     */
    async initRedPacket() {
      const ids = []
      let redpackets = this.compProps.mate.items
      redpackets.forEach((redpacket) => {
        ids.push(parseInt(redpacket.id, 10))
      })
      try {
        const res = await fetchCommodity(ids)
        const commitData = res.value
        if (commitData && commitData.errcode === 0) {
          redpackets.forEach((item = {}, index) => {
            item.bought = commitData.data.items[index] && commitData.data.items[index].bought
            item.unableSell = commitData.data.items[index] && commitData.data.items[index].checkAvailable
            item.offerPrice = commitData.data.items[index] && commitData.data.items[index].offerPrice
          })
          this.$emit('init', redpackets || [])
        } else {
          this.$emit('init', [])
        }
      } catch (error) {}
    },
    /**
     * 显示toast
     * @param {String} msg toast内容
     */
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },

    goList(newVal) {
      const sessionUrl = getSession(sessionKeys.JUMP_LIST_URL)
      const url = newVal.useUrl || (`${sessionUrl}&fromPage=cms_${this.$root.promotionId}&refPage=cms_${this.$root.promotionId}`)
      setTimeout(() => openScheme(url), 20)
    },

    openCashier(params = {}) {
      const { orderNo, token, touchCashierUrl, fKey } = params
      // 小程序
      if (Sniff.miniprogram) {
        // orderType 小程序页支付参数 1是房单 2是增值 由于小程序有页面内跳转订单详情页的逻辑 这里加个字段进行控制
        const url = `/pages/bnb/pay/index?orderNo=${orderNo}&token=${token}&cashierUrl=${encodeURIComponent(touchCashierUrl)}&orderType=2`
        const noop = () => {}
        window.wx && wx.miniProgram.navigateTo({
          url,
          success: noop,
          fail: noop,
          complete: noop
        })
      } else if (!Sniff.qunar && !Sniff.miniprogram) {
        // touch
        window.location.href = touchCashierUrl
      } else {
        // 去哪儿客户端
        window.hysdk.qmp.openHybridCashier({
          hbToken: token,
          fKey: fKey,
          success: (res) => {
            const { status } = res
            if (status && (status === 1 || status === 2)) {
              this.doShowToast('购买成功，红包将于5分钟后发放至账户')
              setTimeout(() => {
                this.initRedPacket()
              }, 20)
            }
          },
          fail: () => {}
        })
      }
    },
    /**
     * 购买商品
     */
    buyCommodity(commodity = {}) {
      loginQ().then(async() => {
        try {
          const res = await createOrder({
            productId: commodity.id,
            productName: commodity.itemName,
            offerPrice: commodity.offerPrice
          })
          const orderData = res.value || {}
          if (orderData.errcode === 0) {
            const orderNo = orderData.data.orderNo
            if (orderNo) {
              const param = getPayTokenParam(orderNo)
              const tokenData = await getToken(param)
              if (tokenData && tokenData.errcode === 0) {
                const tokenParam = {
                  ...tokenData.data,
                  orderNo
                }
                this.openCashier(tokenParam)
              }
            } else {
              this.initRedPacket()
              if (orderData.data && !orderData.data.bought) {
                this.doShowToast(orderData.errmsg || '好可惜，该商品已经售完了')
              }
            }
          } else {
            this.doShowToast(orderData.errmsg)
          }
        } catch (error) {
          this.doShowToast('系统开小差了，一会再试试吧')
        }
      })
    }
  }
}
</script>
